import styled from 'styled-components';
import { withShimmer } from '@app/src/common/withShimmer';
import { COLORS } from '@app/src/ui';

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-wrap: wrap;
`;

export const Option = styled.div`
  width: 100%;
  height: 65px;
  padding: 11px 16px;
  overflow: hidden;
  &:not(:last-child) {
    border-bottom: 1px solid ${COLORS.GRAY};
  }
`;

export const Title = styled.div`
  width: 90%;
  height: 16px;
`;

export const Subtitle = styled.div`
  width: 80%;
  height: 14px;
  margin-top: 8px;
`;

export const Shimmer = withShimmer()(styled.div``);
